import axios from "axios"

//const
const QUOTASUMMARY_GET = "increaseQuota/QUOTASUMMARY_GET"
const INCREASE_QUOTA_UPDATE_DATA = "increaseQuota/INCREASE_QUOTA_UPDATE_DATA"
//reducer
export const increaseQuota = (state = {
  quotaList:[],
  months:"",
  databaseSize:"",
},action) => {
  switch(action.type) {
    case QUOTASUMMARY_GET:
      console.log("quota",action.data);
        return {
          ...state,
          quotaList: action.data
        }

    case INCREASE_QUOTA_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      }
    default:
      return state
  }
}


//actions

export const getQuotaSummary = (enterpriseId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-tenant/org-quotas/?enterprise-code=` + enterpriseId,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("QuotaSummary",response.data);
        dispatch(getQuotaSummaryDone(response.data))
      }
    })
};

export const getQuotaSummaryDone = (data) => {
  return {
    type: QUOTASUMMARY_GET,
    data: data
  }
};

export const updateIncreaseQuotaData = (data) => {
  return {
    type: INCREASE_QUOTA_UPDATE_DATA,
    data: data
  }
}

